// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-group{
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  min-height: 400px;
  padding: 20px;
  background-color: inherit;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  margin-top: 20px;
}


.group-container {
  display: flex;
  gap: 20px;
  max-width: 800px;
}

.people-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.search input {
  margin-bottom: 20px;
  padding: 10px;
  font-size: 14px;
  width: 300px;
}

.people-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.people-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 700px;
  max-height: 75px;
  padding: 15px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.people-card:hover {
  transform: scale(1.05);
}

.profile-info {
  display: flex;
  align-items: center;
}

.people-card img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 15px;
}

.prof h3 {
  margin: 0;
}

.prof p {
  color: #555;
}

.join_btn button {
  background-color: #0073b1;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  font-size: 14px;
}

.profile-details {
  display: flex;
  justify-content: flex-start;  /* Aligning the profile details to the left side */
  width: 100%;
  max-width: 1300px;
  margin-top: 40px;
}

.details-info {
  display: flex;
  align-items: center;
}

.details-info img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 20px;
}

.details-text {
  flex-grow: 1;
}

.details-text h2 {
  margin: 0;
}

.details-text ul {
  list-style: none;
  padding: 0;
}

.close-btn {
  background-color: #fcf9f9;
  color: rgb(8, 1, 1);
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .profile-details {
    flex-direction: column;
   
  }
  .container-group{
    margin-top: 100px; 
  }
 
}
`, "",{"version":3,"sources":["webpack://./src/components/Groups.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B,GAAG,kDAAkD;EAChF,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;;EAExB;EACA;IACE,iBAAiB;EACnB;;AAEF","sourcesContent":[".container-group{\n  width: 100%;\n  max-width: 1300px;\n  margin: 0 auto;\n  min-height: 400px;\n  padding: 20px;\n  background-color: inherit;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-sizing: border-box;\n  margin-top: 20px;\n}\n\n\n.group-container {\n  display: flex;\n  gap: 20px;\n  max-width: 800px;\n}\n\n.people-page {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.search input {\n  margin-bottom: 20px;\n  padding: 10px;\n  font-size: 14px;\n  width: 300px;\n}\n\n.people-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.people-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 700px;\n  max-height: 75px;\n  padding: 15px;\n  text-align: center;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease;\n}\n\n.people-card:hover {\n  transform: scale(1.05);\n}\n\n.profile-info {\n  display: flex;\n  align-items: center;\n}\n\n.people-card img {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 50%;\n  margin-right: 15px;\n}\n\n.prof h3 {\n  margin: 0;\n}\n\n.prof p {\n  color: #555;\n}\n\n.join_btn button {\n  background-color: #0073b1;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 10px;\n  font-size: 14px;\n}\n\n.profile-details {\n  display: flex;\n  justify-content: flex-start;  /* Aligning the profile details to the left side */\n  width: 100%;\n  max-width: 1300px;\n  margin-top: 40px;\n}\n\n.details-info {\n  display: flex;\n  align-items: center;\n}\n\n.details-info img {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  border-radius: 50%;\n  margin-right: 20px;\n}\n\n.details-text {\n  flex-grow: 1;\n}\n\n.details-text h2 {\n  margin: 0;\n}\n\n.details-text ul {\n  list-style: none;\n  padding: 0;\n}\n\n.close-btn {\n  background-color: #fcf9f9;\n  color: rgb(8, 1, 1);\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 768px) {\n  .profile-details {\n    flex-direction: column;\n   \n  }\n  .container-group{\n    margin-top: 100px; \n  }\n \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
